import { useRouter } from 'next/router';

import { SourceDomain } from '@pflegia/types/api/source-domain';
import { Flavor as FlavorEnum } from '@pflegia/types/common/enums/flavor.enum';
import { getSourceDomainName } from '@pflegia/util/common/source-domain/get-source-domain-name';

export interface FlavorFromRoute {
  flavor: FlavorEnum;
  sourceDomain: SourceDomain;
  sourceDomainName: string;
  isPraxia: boolean;
}

/**
 * Hook to get flavor information from the route params.
 * Requires pages to be under a [flavor] structure.
 *
 * @returns Flavor information derived from the current route
 */
export const useFlavorFromRoute = (): FlavorFromRoute => {
  const router = useRouter();
  const flavorParam = router.query.flavor as FlavorEnum | undefined;

  // Default to Pflegia if no flavor param
  const flavor = flavorParam || FlavorEnum.Pflegia;
  const isPraxia = flavor === FlavorEnum.Praxia;
  const sourceDomain = isPraxia ? SourceDomain.PraxiaDe : SourceDomain.PflegiaDe;
  const sourceDomainName = getSourceDomainName(sourceDomain);

  return {
    flavor,
    sourceDomain,
    sourceDomainName,
    isPraxia,
  };
};
